import React, { } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Container, Row, NavLink, Col, Nav, Navbar, Collapse, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Steps } from 'antd';
import { FaChevronUp, FaCheckCircle } from 'react-icons/fa';
import './WizardMenu.css';

function WizardMenu({ wizardDetails, pageReload }) {
    const location = useLocation();
    var pathname = location.pathname.replace('/', '');
    if (pathname == "")
    {
        window.open('Home', "_self");
    }
    const [selectedTabIndex, setSelectedTabIndex] = useState(pathname == 'catchmentcontext' || pathname == 'enterprises' ? 0 :
        ((pathname == 'outline' || pathname == 'mahingakai' || pathname == 'lmu' || pathname == 'infrastructure' || pathname == 'waterways' || pathname == 'effluentdisposal' || pathname == 'freshwaterirrigation') ? 1 :
            ((pathname == 'risk' || pathname == 'contaminantevaluation') ? 2 :
                ((pathname == 'infrastructurerisk' || pathname == 'waterwaysrisk' || pathname == 'landsoil' || pathname == 'cropping' || pathname == 'effluentdisposalrisk' || pathname == 'nutrients' || pathname == 'ghg' || pathname == 'biodiversity' || pathname == 'freshwaterirrigationrisk' || pathname == 'wintergrazing' || pathname == 'biosecurity') ? 3 : 4))));

    const [pageRefresh] = useState(wizardDetails.pageReload);

    const [selectedMenu, setSelectedMenu] = useState(location.pathname.replace('/', ''));

    const { Step } = Steps;

    const onTabChange = async (firstTab) => {
        const hasCVPage = wizardDetails.wizardDetails.wizardItemList
            .filter(item => item.controllerName == "contaminantevaluation");

        if (firstTab == 0) {
            window.open('enterprises', "_self");
        }
        else if (firstTab == 1) {
            window.open('outline', "_self");
        }
        else if (firstTab == 2) {
            if (hasCVPage.length > 0) {
                window.open('contaminantevaluation', "_self");
            }
            else {
                window.open('risk', "_self");
            }
        }
        else if (firstTab == 3) {
            window.open('infrastructurerisk', "_self");
        }
        else if (firstTab == 4) {
            window.open('summary', "_self");
        }
    }
    //const onTabChangeCompleted = async (CompletedfirstTab) => {
    //    if (CompletedfirstTab == 0) {
    //        window.open('summary', "_self");
    //    }
    //    else if (CompletedfirstTab == 1) {
    //        window.open('infrastructure', "_self");
    //    }
    //    else if (CompletedfirstTab == 2) {
    //        window.open('catchmentcontext', "_self");
    //    }
    //    else if (CompletedfirstTab == 3) {
    //        window.open('outline', "_self");
    //    } 
    //}
    const onStepChange = async (menu) => {
        window.open(menu, "_self");
    }

    const renderWizard = (Model) => {
        const wizardDetails = Model.wizardDetails;
        const IsWizardCompleted = wizardDetails.isCompleted == true ? true : false;

        //Parent Menu  Enable  & Disable if  IsWizardCompleted = false


        //Step 1
        let isCatchmentContextCompleted = false;

        let itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == 2)[0];
        if (itemStyle.stringDisabled == "Completed") {
            isCatchmentContextCompleted = true;
        }

        const part1CompleteddivClass = wizardDetails.isCatchmentContextSaved == true && isCatchmentContextCompleted == true ? "completed-check-show" : "completed-check-not-show";
        const part1CompletedClass = wizardDetails.isCatchmentContextSaved == true && isCatchmentContextCompleted == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
        const part2Disabled = wizardDetails.isCatchmentContextSaved == true && isCatchmentContextCompleted == true ? false : true;

        //Step 2  

        let isMahingaKaiCompleted = false;

        itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == 9)[0];
        if (itemStyle.stringDisabled == "Completed") {
            isMahingaKaiCompleted = true;
        }

        const part2CompleteddivClass = wizardDetails.isMahingaKaiSaved == true && isMahingaKaiCompleted == true ? "completed-check-show" : "completed-check-not-show";
        const part2CompletedClass = wizardDetails.isMahingaKaiSaved == true && isMahingaKaiCompleted == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
        let part3Disabled = wizardDetails.isMahingaKaiSaved == true && isMahingaKaiCompleted == true ? false : true;

        //Step 3 
        let isRiskSummaryCompleted = false;

        itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == 11)[0];
        if (itemStyle.stringDisabled == "Completed") {
            isRiskSummaryCompleted = true;
        }
        const part3CompleteddivClass = wizardDetails.isRiskSummarySaved == true && isRiskSummaryCompleted == true ? "completed-check-show" : "completed-check-not-show";
        const part3CompletedClass = wizardDetails.isRiskSummarySaved == true && isRiskSummaryCompleted == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
        let part4Disabled = wizardDetails.isRiskSummarySaved == true && isRiskSummaryCompleted == true ? false : true;

        //Step 4
        let part5Disabled = true;
        let part4CompletedClass = "react-tabs__tab";
        let part4CompleteddivClass = "completed-check-not-show";

        const hasBiosecurityPage = wizardDetails.wizardItemList
            .filter(item => item.controllerName == "biosecurity");

        const hasGHGPage = wizardDetails.wizardItemList
            .filter(item => item.controllerName == "ghg");

        const hasWintergrazingPage = wizardDetails.wizardItemList
            .filter(item => item.controllerName == "wintergrazing");

        const hasBiodiversityPage = wizardDetails.wizardItemList
            .filter(item => item.controllerName == "biodiversity");

        if (hasBiosecurityPage.length > 0) {
            let isBiosecurityCompleted = false;

            itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == 22)[0];
            if (itemStyle.stringDisabled == "Completed") {
                isBiosecurityCompleted = true;
            }
            part4CompletedClass = wizardDetails.isBiosecuritySaved == true && isBiosecurityCompleted == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
            part4CompleteddivClass = wizardDetails.isBiosecuritySaved == true && isBiosecurityCompleted == true ? "completed-check-show" : "completed-check-not-show";
            part5Disabled = wizardDetails.isBiosecuritySaved == true && isBiosecurityCompleted == true ? false : true;
        }
        else if (hasGHGPage.length > 0) {
            let isGHGCompleted = false;

            itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == 21)[0];
            if (itemStyle.stringDisabled == "Completed") {
                isGHGCompleted = true;
            }
            part4CompletedClass = wizardDetails.isGHGSaved == true && isGHGCompleted == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
            part4CompleteddivClass = wizardDetails.isGHGSaved == true && isGHGCompleted == true ? "completed-check-show" : "completed-check-not-show";
            part5Disabled = wizardDetails.isGHGSaved == true && isGHGCompleted == true ? false : true;
        }
        else if (hasBiodiversityPage.length > 0) {
            let isBioDiversityCompleted = false;

            itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == 20)[0];
            if (itemStyle.stringDisabled == "Completed") {
                isBioDiversityCompleted = true;
            }
            part4CompletedClass = wizardDetails.isBioDiversitySaved == true && isBioDiversityCompleted == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
            part4CompleteddivClass = wizardDetails.isBioDiversitySaved == true && isBioDiversityCompleted == true ? "completed-check-show" : "completed-check-not-show";
            part5Disabled = wizardDetails.isBioDiversitySaved == true && isBioDiversityCompleted == true ? false : true;
        }
        else if (hasWintergrazingPage.length > 0) {
            let isWinterGrazingCompleted = false;

            itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == 19)[0];
            if (itemStyle.stringDisabled == "Completed") {
                isWinterGrazingCompleted = true;
            }
            part4CompletedClass = wizardDetails.isWinterGrazingSaved == true && isWinterGrazingCompleted == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
            part4CompleteddivClass = wizardDetails.isWinterGrazingSaved == true && isWinterGrazingCompleted == true ? "completed-check-show" : "completed-check-not-show";
            part5Disabled = wizardDetails.isWinterGrazingSaved == true && isWinterGrazingCompleted == true ? false : true;
        }
        else {
            let isNutrientsCompleted = false;

            itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == 18)[0];
            if (itemStyle.stringDisabled == "Completed") {
                isNutrientsCompleted = true;
            }
            part4CompletedClass = wizardDetails.isNutrientsSaved == true && isNutrientsCompleted == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";
            part4CompleteddivClass = wizardDetails.isNutrientsSaved == true && isNutrientsCompleted == true ? "completed-check-show" : "completed-check-not-show";
            part5Disabled = wizardDetails.isNutrientsSaved == true && isNutrientsCompleted == true ? false : true;
        }

        //Step 5

        const part5CompleteddivClass = wizardDetails.isCompleted == true ? "completed-check-show" : "completed-check-not-show";
        const part5CompletedClass = wizardDetails.isCompleted == true ? "react-tabs__tab stepCompleted" : "react-tabs__tab";

        let current = 0;
        const selectedWizard = wizardDetails.wizardItemList
            .filter(item => item.showInWizard && item.controllerName == pathname)

        wizardDetails.wizardItemList
            .filter(item => item.showInWizard && item.parentSection == selectedWizard[0].parentSection)
            .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
            .map(function (menuItem, index) {
                if (menuItem.controllerName == pathname) {
                    current = index;
                }
            })



        /* if (IsWizardCompleted != true) {*/
        return (
            <Container>
                <Tabs className="Tabs" selectedTabClassName="bg-white" selectedIndex={selectedTabIndex} onSelect={(firstTab) => onTabChange(firstTab)} >
                    <TabList>
                        <Tab className={part1CompletedClass}><label className="step-Name"> Part 1 – Property and Catchment </label> <FaCheckCircle className={part1CompleteddivClass} size={24} /></Tab>
                        <Tab className={part2CompletedClass} disabled={part2Disabled}><label className="step-Name"> Part 2 – Foundational Mapping </label><FaCheckCircle className={part2CompleteddivClass} size={24} /></Tab>
                        <Tab className={part3CompletedClass} disabled={part3Disabled}><label className="step-Name"> Part 3 – Risk Assessment </label><FaCheckCircle className={part3CompleteddivClass} size={24} /></Tab>
                        <Tab className={part4CompletedClass} disabled={part4Disabled}><label className="step-Name"> Part 4 – Actions to mitigate Risk </label><FaCheckCircle className={part4CompleteddivClass} size={24} /></Tab>
                        <Tab className={part5CompletedClass} disabled={part5Disabled}><label className="step-Name"> Part 5 – Summary </label><FaCheckCircle className={part5CompleteddivClass} size={24} /></Tab>
                    </TabList>
                    <TabPanel>
                        <Steps current={current} labelPlacement="vertical">
                            {wizardDetails.wizardItemList
                                .filter(item => item.showInWizard && item.parentSection == 'PART 1')
                                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                .map(function (menuItem, index) {
                                    let itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == menuItem.id)[0];
                                    if (itemStyle.stringDisabled == "Completed") {
                                        return (
                                            <Step key={menuItem.name} status="finish" title={menuItem.name} onClick={(menu, index) => onStepChange(menuItem.controllerName, index)} />
                                        );
                                    }
                                    else if (itemStyle.stringDisabled == "wizard-disable") {
                                        return (
                                            <Step key={menuItem.name} status="wait" title={menuItem.name} />
                                        );
                                    }
                                    else {
                                        return (
                                            <Step key={menuItem.name} status="process" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                })}
                        </Steps>
                    </TabPanel>
                    <TabPanel >
                        <Steps current={current} labelPlacement="vertical">
                            {wizardDetails.wizardItemList
                                .filter(item => item.showInWizard && item.parentSection == 'PART 2')
                                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                .map(function (menuItem, index) {
                                    let itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == menuItem.id)[0];
                                    if (itemStyle.stringDisabled == "Completed") {
                                        return (
                                            <Step key={menuItem.name} status="finish" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                    else if (itemStyle.stringDisabled == "wizard-disable") {
                                        return (
                                            <Step key={menuItem.name} status="wait" title={menuItem.name} />
                                        );
                                    }
                                    else {
                                        return (
                                            <Step key={menuItem.name} status="process" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                })}
                        </Steps>
                    </TabPanel>
                    <TabPanel>
                        <Steps current={current} labelPlacement="vertical">
                            {wizardDetails.wizardItemList
                                .filter(item => item.showInWizard && item.parentSection == 'PART 3')
                                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                .map(function (menuItem, index) {
                                    let itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == menuItem.id)[0];
                                    if (itemStyle.stringDisabled == "Completed") {
                                        return (
                                            <Step key={menuItem.name} status="finish" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                    else if (itemStyle.stringDisabled == "wizard-disable") {
                                        return (
                                            <Step key={menuItem.name} status="wait" title={menuItem.name} />
                                        );
                                    }
                                    else {
                                        return (
                                            <Step key={menuItem.name} status="process" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                })}
                        </Steps>
                    </TabPanel>
                    <TabPanel>
                        <Steps current={current} labelPlacement="vertical">
                            {wizardDetails.wizardItemList
                                .filter(item => item.showInWizard && item.parentSection == 'PART 4')
                                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                .map(function (menuItem, index) {
                                    let itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == menuItem.id)[0];
                                    if (itemStyle.stringDisabled == "Completed") {
                                        return (
                                            <Step key={menuItem.name} status="finish" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                    else if (itemStyle.stringDisabled == "wizard-disable") {
                                        return (
                                            <Step key={menuItem.name} status="wait" title={menuItem.name} />
                                        );
                                    }
                                    else {
                                        return (
                                            <Step key={menuItem.name} status="process" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                })}
                        </Steps>
                    </TabPanel>
                    <TabPanel>
                        <Steps current={current} labelPlacement="vertical">
                            {wizardDetails.wizardItemList
                                .filter(item => item.showInWizard && item.parentSection == 'PART 5')
                                .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                .map(function (menuItem, index) {
                                    let itemStyle = wizardDetails.wizardStyleList.filter(style => style.wizardId == menuItem.id)[0];
                                    if (itemStyle.stringDisabled == "Completed") {
                                        return (
                                            <Step key={menuItem.name} status="finish" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                    else if (itemStyle.stringDisabled == "wizard-disable") {
                                        return (
                                            <Step key={menuItem.name} status="wait" title={menuItem.name} />
                                        );
                                    }
                                    else {
                                        return (
                                            <Step key={menuItem.name} status="process" title={menuItem.name} onClick={(menu) => onStepChange(menuItem.controllerName)} />
                                        );
                                    }
                                })}
                        </Steps>
                    </TabPanel>
                </Tabs>
            </Container>
        );
    }

    return (
        <div>
            <div className="wizard-menu">
                {renderWizard(wizardDetails)}
            </div>
        </div >
    );

}

export default WizardMenu;